import api from './api';

const treatmentService = {
  // Get all treatments with optional filters
  getAllTreatments: async (params = {}) => {
    const response = await api.get('/treatments', { params });
    return response.data;
  },

  // Get single treatment by ID
  getTreatmentById: async (id) => {
    const response = await api.get(`/treatments/${id}`);
    return response.data;
  },

  // Get treatments for a specific patient
  getPatientTreatments: async (patientId) => {
    const response = await api.get(`/treatments/patient/${patientId}`);
    return response.data;
  },

  // Create new treatment
  createTreatment: async (treatmentData) => {
    const response = await api.post('/treatments', treatmentData);
    return response.data;
  },

  // Update treatment
  updateTreatment: async (id, treatmentData) => {
    const response = await api.put(`/treatments/${id}`, treatmentData);
    return response.data;
  },

  // Delete treatment
  deleteTreatment: async (id) => {
    const response = await api.delete(`/treatments/${id}`);
    return response.data;
  },

  // Get treatment statistics
  getTreatmentStats: async () => {
    const response = await api.get('/treatments/stats');
    return response.data;
  },
};

export default treatmentService;